import { MutableRefObject } from "react"

export const delayAction = (func: () => void, delay: number, timerId: MutableRefObject<NodeJS.Timeout | undefined>) => {
  clearTimeout(timerId.current) // Clear the previous timer, if any

  timerId.current = setTimeout(func, delay)
}